<template>
   <div
      :class="[
         'layout',
         'layout-core-work',
         `discipline-${route.params.discipline}`,
      ]"
   >
      <BreadCrumbs>
         <template #actions>
            <Btn
               :text="{ do: 'Save', done: 'Saved', undo: 'Unsave' }"
               class="yellow"
               action
               :actionActive="isSaved"
               @handle-action="handleSaveCoreWork"
            >
               <IconBookmarkFilled v-if="isSaved" />
               <IconBookmark v-else />
            </Btn>
         </template>
      </BreadCrumbs>
      <div class="core-work-wrapper">
         <NuxtPage />
      </div>
   </div>
</template>

<script setup lang="ts">
import toastMessages from "~/data/content/toast-messages.json";
import IconBookmark from "~/assets/images/icons/bookmark.svg?component";
import IconBookmarkFilled from "~/assets/images/icons/bookmark-filled.svg?component";
const route = useRoute();
const { coreWork, saveCoreWorkToProfile } = useCoreWork();
const { profile, getProfileContent } = useProfile();
const { addToast } = useToast();

// COMPUTED ================
const isSaved = computed(() => {
   let found = false;
   profile?.value?.coreWorks?.length &&
      profile.value.coreWorks.forEach((item) => {
         item?.id === coreWork?.value?.id && (found = true);
      });
   return found;
});

// METHODS ================
const handleSaveCoreWork = () => {
   // Snapshot intent before the API call — `saveCoreWorkToProfile` triggers a
   // profile refresh that can flip `isSaved` before the toast is built.
   const method = isSaved.value ? "DELETE" : "POST";
   saveCoreWorkToProfile(route.params.slug, method)
      .then(() => {
         const toastMessage = method === "DELETE"
            ? { ...toastMessages.removeFromProfile.success }
            : { ...toastMessages.addToProfile.success };
         toastMessage.message = toastMessage.message.replace(
            /%s/,
            coreWork.value.title
         );

         addToast(toastMessage);
      })
      .catch(() => {
         const toastMessage = method === "DELETE"
            ? { ...toastMessages.removeFromProfile.error }
            : { ...toastMessages.addToProfile.error };
         toastMessage.message = toastMessage.message.replace(
            /%s/,
            coreWork.value.title
         );

         addToast(toastMessage);
      });
};

// LIFECYCLE ================
watchEffect(async () => {
   if (profile?.value?.coreWorks) return;
   try {
      await getProfileContent("coreWorks");
   } catch {
      // best-effort prefetch; layout still renders without this data
   }
});
</script>

<style lang="scss">
div.layout-core-work {
   div.core-work-wrapper {
      width: 100dvw;
   }
}
</style>
